import { render, staticRenderFns } from "./WPRegionList.vue?vue&type=template&id=3173fd16&scoped=true&"
import script from "./WPRegionList.vue?vue&type=script&lang=js&"
export * from "./WPRegionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3173fd16",
  null
  
)

export default component.exports